import { Typography } from 'mobily-ui-library/lib'
import './ClusterMapPop.scss';

const ClusterMapPop = ({ places, title }: any) => {
    return (
        <div className='ClusterPopup__container'>
            <Typography className='MPU__text'>{title}</Typography>
        </div>
    )
}


export default ClusterMapPop;